import { useState, useEffect } from "react";
import { GetServices } from "screens/Requests/logic/GetServices";
import { SaveService } from "./SaveService";
import { SaveBundle } from "./SaveBundle";

import { useServicePermission } from "../permissions/ServicePermissions";

export const useBundleLogic = ({ setLoading, toast, navigate, handleCloseBundleDlg, bundleContent,fetchBundles, fetchServices, serviceList }) => {
    
    //#region Permissions
    const { ServicePermissionProps } = useServicePermission();
    const {
        // Service Permissions
        hasServiceGetPermission,

        // Bundle Permissions
        hasBundleSavePermission,
    } = ServicePermissionProps;
    //#endregion Permissions

    const initialBundleState = {
        bundleID: 0,
        bundleName: null,
        description: null,
        isActive: true,
        services: [{serviceOfferingID : 0, flatRate:0}]
      }
    const [bundle, setBundle] = useState(initialBundleState);
    const [bundleErrors, setBundleErrors] = useState({});

    useEffect(() => {
        if(!hasServiceGetPermission){
            fetchServices();
        }
    }, [hasServiceGetPermission]);

    useEffect(() => {
        if (Object.keys(bundleErrors).length > 0) {
            const timer = setTimeout(() => {
                setBundleErrors({});
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [bundleErrors])
    
    const isNumberOnly = (input) => {
        const numberRegex = /^\d*\.?\d*$/   
        return numberRegex.test(input);
      }

    const handleBundleChange = (field, value) => {
        if(!hasBundleSavePermission) return;

        if(field === 'flatRate'){
            if(isNumberOnly(value)){
                setBundle((prevState) => ({ ...prevState, [field]: value }));
            }
        }else{
            setBundle((prevState) => ({ ...prevState, [field]: value }));
        }         
    }

    const validateFields = () => {
        let tempErrors = {};
        if (!bundle?.bundleName?.trim()) tempErrors.bundleName = "Bundle Name is required";
        if (bundle.services.length === 0) tempErrors.services = "At least one service is required";

        bundle.services.forEach((service, index) => {
            if (!service.serviceOfferingID) tempErrors[`service_${index}_serviceOfferingID`] = "Service is required";
            if (!service.flatRate) tempErrors[`service_${index}_flatRate`] = "Flat Rate is required";
        });

        setBundleErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const ResetBundle = () => {
        setBundle(initialBundleState);
    }

    const handleSaveBundle = async () => {
        if(!hasBundleSavePermission) return;

        if (validateFields()) {
            setLoading(true);
            try {
                const result = await SaveBundle(bundle, navigate);
                if (result && !result.isError) {
                    fetchBundles(); 
                    ResetBundle();
                    handleCloseBundleDlg();                   
                    toast.success(bundleContent.notification, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                         theme: "light",
                        style: {
                            fontFamily: '"DM Sans", sans-serif',
                            fontSize: '15px',
                        },
                    });
                } else {
                    toast.error(result.message || 'Bundle failed to saved.', {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        style: {
                            fontFamily: '"DM Sans", sans-serif',
                            fontSize: '15px',
                        },
                    });
                }
            } catch (error) {
                console.error('Error saving Bundle:', error);
            } finally {                
                setLoading(false);
            }
        }
    }

    const handleServiceChange = (index, field, value) => {
      if (field === "serviceOfferingID") {
        const updatedServices = [...bundle.services];
        updatedServices[index] = {
          ...updatedServices[index],
          [field]: value,
          flatRate:
            serviceList.find((service) => service.id === value)?.flatRate || 0,
        };
        setBundle((prev) => ({ ...prev, services: updatedServices }));
      } else {
        const updatedServices = [...bundle.services];
        updatedServices[index] = { ...updatedServices[index], [field]: value };
        setBundle((prev) => ({ ...prev, services: updatedServices }));
      }
    };

    const addService = () => {
    setBundle((prev) => ({
        ...prev,
        services: [...prev.services, { serviceOfferingID: "", flatRate: "" }],
    }));
    };

    const removeService = (index) => {
    setBundle((prev) => ({
        ...prev,
        services: prev.services.filter((_, i) => i !== index),
    }));
    };

    const BundleProps = {
        bundle,
        bundleErrors,
        setBundleErrors,
        handleBundleChange,
        handleServiceChange,
        addService,
        removeService,
        validateFields,
        ResetBundle,
        handleSaveBundle,
        setBundle,
        serviceList,
    }

    return { BundleProps };

}